import { useAuth } from '@clerk/clerk-react';
import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const DOCUMENSO_URL = import.meta.env.VITE_REDIRECT_URL;

export const useDocumensoRedirect = () => {
  const { getToken } = useAuth();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const redirectToDocumenso = useCallback(
    async (destinationPath?: string, tab?: Window) => {
      setIsLoading(true);
      setError(null);
      try {
        const token = await getToken();
        if (!token) {
          throw new Error('Session expired. Please sign in again.');
        }

        const redirectUrl = new URL('/auth/clerk', DOCUMENSO_URL);
        redirectUrl.searchParams.set('clerk_token', token);
        redirectUrl.searchParams.set('redirect_url', destinationPath || '/documents');
        if (tab) {
          tab.location.href = redirectUrl.toString();
        } else {
          window.open(redirectUrl.toString(), '_blank');
        }
      } catch (err) {
        setIsLoading(false);
        setError(err instanceof Error ? err.message : t('messages.unexpectedErrorMessage'));
      }
    },
    [getToken, t]
  );

  return { redirectToDocumenso, isLoading, error };
};
